import { signal } from "@preact/signals-react"

export const marketAnalyzerChartActualPrice = signal(true)
export const marketAnalyzerEvolutionSkuFilters = signal({})
export const marketAnalyzerCurrentPeriod = signal("")
export const marketAnalyzerEvolutionSkuCurrentPeriod = signal("")
export const marketAnalyzerEndDate = signal("")

export const marketAnalyzerEvolutionOffersFilters = signal({})
export const marketAnalyzerEvolutionOffersDatePeriod = signal("")

export const marketAnalyzerSkuDetailsFilters = signal({})

export const marketAnalyzerIsEmpty = signal(false)

export const marketAnalyzerReportFormIsOpen = signal(false)
export const marketAnalyzerSubmittedFilters = signal({})


export const resetPricingMarket = () => {
    marketAnalyzerChartActualPrice.value = true
    marketAnalyzerIsEmpty.value = false
    marketAnalyzerEvolutionSkuFilters.value = {}
    marketAnalyzerEvolutionOffersFilters.value = {}
    marketAnalyzerSkuDetailsFilters.value = {}
    marketAnalyzerCurrentPeriod.value = ""
}